<app-layout title="Notificaciones">
  <div class="container mt-3">
    <!--   <h5>Notificaciones</h5>
 -->
    <div *ngIf="notifications.length === 0">
      <p class="text-muted">No hay notificaciones.</p>
    </div>

    <div *ngFor="let notification of notifications" class="card mb-2"
      [ngClass]="{'border-info': notification.type === 'info', 'border-success': notification.type === 'success', 'border-warning': notification.type === 'warning', 'border-danger': notification.type === 'error'}">
      <div class="card-body">
        <h6 class="card-title">
          {{ notification.title }}
          <span *ngIf="!notification.read" class="badge bg-primary ms-2">Nueva</span>
        </h6>
        <p class="card-text">{{ notification.message }}</p>
        <small class="text-muted">{{ notification.createdAt | date:'short' }}</small>
        <div class="mt-2">
          <button *ngIf="!notification.read" class="btn btn-sm btn-outline-primary"
            (click)="markAsRead(notification._id)">
            Marcar como leída
          </button>
          <button class="btn btn-sm btn-outline-danger ms-2" (click)="deleteNotification(notification._id)">
            Eliminar
          </button>
          <a *ngIf="notification.link" [href]="notification.link" class="btn btn-sm btn-link ms-2">Ver más</a>
        </div>
      </div>
    </div>
  </div>
</app-layout>